import React, { useState, useCallback } from 'react';
import { Select, MenuItem, InputLabel, FormControl, FormHelperText } from '@material-ui/core';

type FormSelectProps = {
    value?: string;
    onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    label?: React.ReactNode;
    optionList: { value: string; name: React.ReactNode; description?: string }[];
    optionListIsLoading?: boolean;
    placeholder?: React.ReactNode;
    errors?: string[];
    formItemKey: string;
    fullWidth: boolean
};

const FormSelect = ({
    value = '',
    onChange,
    label,
    optionList = [],
    optionListIsLoading = false,
    errors = [],
    placeholder = '',
    formItemKey,
    fullWidth
}: FormSelectProps): React.ReactElement => {
    const [selectedValue, setSelectedValue] = useState(value);

    const handleOnChange = useCallback(
        (event) => {
            setSelectedValue(event.target.value);

            if (onChange) {
                onChange(event);
            }
        },
        [onChange]
    );

    return (
        <>
            <FormControl fullWidth={fullWidth}>
                {label && (
                    <InputLabel shrink htmlFor={formItemKey}>
                        {label}
                    </InputLabel>
                )}
                <Select
                    autoWidth
                    disabled={optionListIsLoading}
                    onChange={handleOnChange}
                    value={selectedValue}
                >
                    {optionList.map((option) => (
                        <MenuItem id="yeself-menu-item" key={option.value} value={option.value}>
                            {option.name}
                            <span>{option.description}</span>
                        </MenuItem>
                    ))}
                </Select>
                {errors && errors.length > 0 && <FormHelperText>{placeholder}</FormHelperText>}
            </FormControl>
        </>
    );
};
export default FormSelect;
